import { ThemeId } from '@/app/components/lang-colors'
import { SourceLanguageCode, TargetLanguageCode } from 'deepl-node'

export const DELIMITER = '&'

const tl: TargetLanguageCode[] = ['en-US', 'es', 'it', 'fr']
export const defaultSearchParams: {
    tl: string
    ftl: string
    sl: SourceLanguageCode
    text: string
} = {
    tl: tl.join(DELIMITER),
    ftl: tl.join(DELIMITER),
    sl: 'en',
    text: 'Hello!',
}
export const defaultTheme: ThemeId = 'dracula'
export const tooManyChars = 'too-many'
export const tooManyLangs = 'too-many-langs'
export const maxCharacters = 800
export const maxLangs = 12
